import type { RouteRecordRaw } from 'vue-router'

export const authRoutes: Array<RouteRecordRaw> = [
  // Profile
  {
    path: 'profile',
    name: 'Profile',
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/views/ProfileView.vue'),
  },
  // Labs
  {
    path: 'labs',
    name: 'Labs',
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/views/labs/LabsListView.vue'),
    children: [
      {
        path: ':labID/info',
        name: 'LabEditInfo',
        meta: {
          requiresAuth: true,
          parentRouteName: 'Labs',
        },
        component: () => import('@/views/labs/LabEditInfoView.vue'),
      },
      {
        path: ':labID/billing',
        name: 'LabEditBilling',
        meta: {
          requiresAuth: true,
          parentRouteName: 'Labs',
        },
        component: () => import('@/views/labs/LabEditBillingView.vue'),
      },
    ],
  },
  // Admin Users
  {
    path: 'admin-users',
    name: 'AdminUsers',
    meta: {
      requiresAuth: true,
      permission: 'users.view',
    },
    component: () => import('@/views/adminUsers/AdminUsersListView.vue'),
    children: [
      {
        path: ':userID/info',
        name: 'AdminUserEditInfo',
        meta: {
          requiresAuth: true,
          parentRouteName: 'AdminUsers',
        },
        component: () => import('@/views/adminUsers/AdminUserEditInfoView.vue'),
      },
    ],
  },
]
